/* eslint-disable no-nested-ternary */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useTable, useSortBy } from 'react-table';
import styled from 'styled-components';

const TdWrapper = styled.td`
    position: relative;

    &:first-child:after {
        background: ${props =>
            ` ${props.color ? `${props.color} !important` : 'transparent'}`};
        border-radius: 20%;
        /* border: 2px solid transparent;
        border-color: ${props =>
            ` ${props.color ? `${props.color} !important` : 'transparent'}`};
        border-radius: 400px;
        border-width: 0 0 0 3px; */
        content: '';
        height: 20px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
    }
`;

const Cell = ({ cell, data }) => {
    const isPercent = cell.column.id === 'percentage';
    return (
        <span className="cell-text" title={cell.value}>
            {cell.value || cell.value === 0
                ? `${cell.value} ${isPercent ? '%' : ''}`
                : '-'}
        </span>
    );
};

const StatusTable = ({ columns, data, customClass, initialState }) => {
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headers,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            disableSortRemove: true,
            initialState,
        },
        useSortBy
    );

    // Render the UI for your table
    return (
        <table {...getTableProps()} className={customClass}>
            <thead>
                <tr>
                    {headers.map(column => (
                        // Add the sorting props to control sorting. For this example
                        // we can add them into the header props
                        <th
                            {...column.getHeaderProps(
                                column.getSortByToggleProps()
                            )}
                        >
                            {column.header}
                            {/* Add a sort direction indicator */}
                            <span>
                                {column.isSorted ? (
                                    column.isSortedDesc ? (
                                        <span className="sort-icon descending">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
                                                />
                                            </svg>
                                        </span>
                                    ) : (
                                        <span className="sort-icon ascending">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
                                                />
                                            </svg>
                                        </span>
                                    )
                                ) : (
                                    ''
                                )}
                            </span>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                const { original } = cell.row;
                                return (
                                    <TdWrapper
                                        color={
                                            (original && original.color) ||
                                            `#000`
                                        }
                                        {...cell.getCellProps()}
                                    >
                                        <Cell cell={cell} data={row} />
                                    </TdWrapper>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

StatusTable.propTypes = {
    customClass: PropTypes.string,
    columns: PropTypes.array,
    data: PropTypes.array,
    initialState: PropTypes.object,
};

Cell.propTypes = {
    cell: PropTypes.object,
    data: PropTypes.object,
};

export default StatusTable;
